import { useMutation } from '@tanstack/react-query';
import api from '../../services/api';

export const MUTATION_KEY_TOTEM_SEND_LOGCAT = 'TOTEM_SEND_LOGCAT';

interface UseSendLogcatCommandParams {
    totemId: number | undefined;
}

interface LogcatResponse {
    sentCommand: {
        success: boolean;
        payload?: {
            downloadUrl?: string;
        };
    };
}

export function useSendLogcatCommand() {
    const mutationFn = async (params: UseSendLogcatCommandParams) => {
        if (!params.totemId) return null;

        const { data } = await api.post<LogcatResponse>(
            '/totem/send-logcat-command',
            { totemId: params.totemId },
        );

        return data;
    };

    return useMutation({
        mutationFn,
        mutationKey: [MUTATION_KEY_TOTEM_SEND_LOGCAT],
    });
}
